<script>
import pageMixin from '@src/mixins/pagination'
import { genderFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import { memberComputed } from '@state/helpers'
import changePageMixin from '@src/mixins/changePage'
export default {
  components: {
  },
  filters: {
    genderFilter,
    formatDate,
  },
  mixins: [pageMixin, changePageMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      tableData: [
        {
          id: 1223,
        },
      ],
      allMembers: [],
      dialogVisible: false,
      selectAllDialogVisible: false,
      selectedMember: [],
      tagList: [],
      tryingToSend: false,
      tryingFetchTag: false,
      membersLimit: 0,
      membersUsed: 0,
      currentPage: 1, // 現在的分頁
      handleSelected: new Map(), // 目前各分頁選到的列
      apiSliceNumber: 5, // 多少個資料打一次api
    }
  },
  computed: {
    ...memberComputed,
    enabledBulkButton() {
      return this.selectedMember.length === 0
    },
    enabledCopyButton() {
      return this.selectedMember.length === 1
    },
    memberIds() {
      return this.selectedMember.map((member) => member.id)
    },
    availableMembers() {
      return this.allMembers
    },
  },

  watch: {
    currentPage: {
      async handler(nvl, ovl) {
        this.handleSelected.set(ovl, this.selectedMember)
        await this.tryToSearch()
      },
      // immediate: true,
    },
  },
  created() {
    this.tryToSearch()
  },
  methods: {
    async tryToSearch() {
      try {
        if (this.defaultValue.id) {
          let result = await this.$store.dispatch('member/fetchList', {
            paginate: 1,
            couponId: this.defaultValue.id,
            page: this.currentPage,
            limit: 10
          })
          const { items } = result
          this.allMembers = items
          this.$nextTick(() => {
            this.$refs.pagination && this.$refs.pagination.updateTotal(result.total)
          })
          this.reductionSelected(this.currentPage, this.availableMembers, this.$refs.multipleTable)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    handleSelectionChange(selected) {
      this.selectedMember = []
      selected.forEach(item => {
        this.selectedMember.push(item)
      })
    },
    async tryToFetchTag() {
      this.tryingFetchTag = true
      this.tagList = await this.$store.dispatch('member/fetchTags', {
        search: '',
      })
      this.tryingFetchTag = false
    },
    async tryToRemove() {
      await this.$confirm('確定刪除該適用對象？', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
    },
    /**
     * @description 發送優惠券
     */
    async tryToSend(type) {
      try {
        this.handleSelected.set(this.currentPage, this.selectedMember)
        let mergedArray = this.mergedArray()
        if(mergedArray.length === 0 && type === 'selected'){
          this.$message.error('請先選取會員')
          return 
        }
        if (type === 'selected') {
          await this.$confirm(`確定發送${mergedArray.length}張優惠券`, '發送優惠卷', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            showCancelButton: true,
            dangerouslyUseHTMLString: true,
            customClass: 'isStyleBtnFull',
            confirmButtonClass: 'isConfirmBtn',
            cancelButtonClass: 'isCancelBtn',
            center: true,
          })
        }
        if (type === 'all') {
          await this.$confirm(`確定對所有會員發送優惠券？`, '發送優惠卷', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            showCancelButton: true,
            dangerouslyUseHTMLString: true,
            customClass: 'isStyleBtnFull',
            confirmButtonClass: 'isConfirmBtn',
            cancelButtonClass: 'isCancelBtn',
            center: true,
          })
        }
        this.tryingToSend = true
        if (type === 'selected') {
          await this.storeSelectedData(mergedArray)
        } else {
          await this.storeAllData()
        }
      } finally {
        this.tryingToSend = false
      }
    },
    /**
     * @description 對部分會員發送優惠券
     */
    async storeSelectedData(mergedArray) {
      const sendData = {
        memberIds: this.splitMergeArray(mergedArray),
        couponCode: this.defaultValue.code,
      }
      this.composeApi(sendData['memberIds'])
    },
    /**
     * @description 組成API格式發送出去
     */
    async composeApi(allMeberId) {
      try {
        // allMeberId 資料格式：[[],[],[],[],[],[]] => 每5個為一個單位，打一次ａｐｉ
        for (let i = 0, len = Math.floor(allMeberId.length / this.apiSliceNumber); i <= len; i++) {
          // 每5個為一個單位抽出來
          const elements = allMeberId.slice(i * this.apiSliceNumber, (i + 1) * this.apiSliceNumber)
          const requests = [];
          // 然後5個內的每一個都是陣列，要再將其抽出
          for (let j = 0, lenj = elements.length; j < lenj; j++) {
            try {
              const request = this.$store.dispatch('coupon/sendCoupon', {
                memberIds: elements[j],
                couponCode: this.defaultValue.code,
              });
              // 理論上這邊最多100個
              requests.push(request)
            } catch (error) {
              console.error(error.message)
            }
          }
          await Promise.all(requests);
          await this.sleep(1000);
        }
        this.$message({ message: '發送成功！', type: 'success' })
        this.resetCurrentPage()
      } catch (error) {
        console.error(error.message)
      }
    },
    /***
     * @description 對所有會員發送優惠券
     */
    async storeAllData() {
      try {
        const sendData = {
          memberIds: [],
          couponCode: this.defaultValue.code,
        }
        await this.$store.dispatch('coupon/sendCoupon', sendData)
        this.$message({ message: '發送成功！', type: 'success' })
        this.resetCurrentPage()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 將頁面復原
     */
    async resetCurrentPage() {
      this.currentPage = 1 // 現在的分頁
      this.handleSelected = new Map() // 目前各分頁選到的列
      this.selectedMember = []
      await this.tryToSearch()
    },
    changePage(value) {
      this.$emit('changePage', value)
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <BasePageHeader>
      <template v-slot:title>優惠券之適用對象</template>
      <template v-slot:right>
        <el-button class="is-round" @click="changePage(0)">
          <span>編輯適用對象</span>
        </el-button>
        <el-button class="is-round" type="primary" @click="tryToSend('all')">
          <span>全部發送</span>
        </el-button>
        <el-button class="is-round" type="primary" @click="tryToSend('selected')">
          <span>選取發送</span>
        </el-button>
      </template>
    </BasePageHeader>
    <div class="el-table-wrapper px-0">
      <el-table ref="multipleTable" element-loading-text="取得適用對象資訊中" :data="availableMembers" class="isBgDark"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="75">
        </el-table-column>
        <el-table-column v-slot="{ row }" label="姓名電話" min-width="150">
          <b>{{ row.fullName }} {{ row.gender | genderFilter }}</b>
          <div>{{ `${row.phoneCode} ${row.phoneNumber}` }}</div>
        </el-table-column>
        <el-table-column v-slot="{ row }" label="標籤" min-width="130">
          <div>
            <el-tag v-for="tag in row.tags" :key="`tag-${tag.id}`" disable-transitions class="isStyleTag">
              {{ tag.title }}
            </el-tag>
          </div>
        </el-table-column>
        <el-table-column label="有效訂單" min-width="90" prop="ordersCounts"></el-table-column>
        <el-table-column v-slot="{ row }" :label="`總消費金額${$hasDeposit() ? ' 與點數餘額' : ''}`" min-width="130"
          prop="ordersTotal" style="word-break: keep-all;">
          <span>${{ row.ordersTotal }}</span>
          <div v-if="$hasDeposit()" class="fs-sm text-secondary-light">點數餘額：{{ row.reduce }}</div>
        </el-table-column>
        <el-table-column v-slot="{ row }" min-width="150" label="最後訂單日期">
          <div class="Jost" style="font-weight: 500">{{ row.lastOrderDate | formatDate }}</div>
          <span>{{ row.lastOrderDate | formatDate('HH:mm') }}</span>
        </el-table-column>
      </el-table>
    </div>
    <BasePagination ref="pagination" :current-page.sync="currentPage" />
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
